import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchItems } from "../../features/items/itemsSlice";
import Transaction from "./Transaction";

export default function Transactions() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchItems());
  }, [dispatch]);
  const { isLoding, isError, items, error } = useSelector(
    (state) => state.item
  );

  let content;
  let last5 = items.slice(-5);
  const transactions = last5.reverse();

  if (isLoding && !isError) {
    content = <p>......loding......</p>;
  }
  if (!isLoding && isError) {
    content = <p>{error}</p>;
  }
  if (!isLoding && !isError && items.length > 0) {
    content = transactions?.map((item) => (
      <Transaction key={item.key} item={item} />
    ));
  }
  if (!isLoding && !isError && items.length === 0) {
    content = <p className="nothing ">There is no content!!</p>;
  }

  return (
    <>
      <p className="second_heading">Your Transactions:</p>

      <div className="conatiner_of_list_of_transactions">
        <ul>{content}</ul>
      </div>
      <div>
        {" "}
        <Link to="/items">
          <p className="bg-teal-500 button">View All</p>
        </Link>
      </div>
    </>
  );
}
